export const initialKpiPerformace = () => ({
    listAll: [],
});


export const kpiPerformace = (currentState, action) => {
    let kpiPerformance = {
        listAll: [],
        loading: action.loading ?? currentState.loading, 
    }

    const currentDate = action.selectedDate ? new Date(action.selectedDate) : new Date();
    const currentMonth = currentDate.getMonth() + 1;  // Mês de 1 a 12
    const currentDay = currentDate.getDate();
    const currentYear = currentDate.getFullYear();
    
    kpiPerformance.selectedDate = currentDate;
    kpiPerformance.currentDate = currentMonth;
    kpiPerformance.currentMonth = currentMonth;
    kpiPerformance.currentDay = currentDay;
    kpiPerformance.currentYear = currentYear;
    kpiPerformance.date = new Date(); 
    kpiPerformance.isCurrentMonth = currentMonth === kpiPerformance.date.getMonth() + 1;
    kpiPerformance.listAll = action.kpiPerformance || [];
    kpiPerformance.compareWith = action.compareWith
    
    return {
        ...currentState,
        kpiPerformance
    }
}

